/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
// CON-165: the dashboard's Tailwind entry is emitted HERE, immediately before
// donationform.css, because that is where v3's one surviving copy of Tailwind
// sat in the bundle and the dashboard's unlayered cascade depends on that
// position (src/tailwind.css says why). Every importer of donationform.css
// carries this line; whichever the bundle reaches first places it.
import '../../tailwind.css';
import './donationform.css';
import './toggle.css';

export default function ConfirmationTicket(props) {
  const {
    selectedSubscription,
    donationAmount,
    frequency,
    createDonationCard,
    createDonationBank,
    errorMessageFromParent,
  } = props;

  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root
      show={props.openConfirmation}
      as={Fragment}
      unmount={props.draweropenConfirmation}
    >
      <Dialog
        as="div"
        className="relative z-20"
        initialFocus={cancelButtonRef}
        onClose={props.setOpenConfirmation}
        unmount={props.draweropenConfirmation}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          unmount={props.draweropenConfirmation}
        >
          <div className="fixed inset-0 bg-ink-muted bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              unmount={props.draweropenConfirmation}
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div className="items-center justify-center sm:flex">
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <div className="">
                      <div className="grid grid-cols-2">
                        <p className="col-span-1 mt-2 flex items-center text-sm text-ink-muted"></p>
                      </div>
                    </div>
                    <div className="mt-2 flex justify-between"></div>
                    <div className="mt-2">
                      <p className="text-sm text-ink-muted">
                        <div className="FormBoxConfirm" id="FormBoxConfirm">
                          <form>
                            <div
                              style={{
                                top: '5%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                animationDelay: '.5s',
                              }}
                            >
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 130.2 130.2"
                                style={{ width: '40px', display: 'block' }}
                              >
                                <circle
                                  className="path circle"
                                  fill="none"
                                  stroke="#73AF55"
                                  strokeWidth="6"
                                  strokeMiterlimit="10"
                                  cx="65.1"
                                  cy="65.1"
                                  r="62.1"
                                />
                                <polyline
                                  className="path check"
                                  fill="none"
                                  stroke="#73AF55"
                                  strokeWidth="6"
                                  strokeLinecap="round"
                                  strokeMiterlimit="10"
                                  points="100.2,40.2 51.5,88.8 29.8,67.5 "
                                />
                              </svg>
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'baseline',
                                textAlign: 'center',
                                justifyContent: 'center',
                                fontSize: '2.0vh',
                                fontWeight: 'bold',
                                marginTop: '5px',
                              }}
                            >
                              {' '}
                              Thank you for the Ticket Purchase!{' '}
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'baseline',
                                justifyContent: 'center',
                              }}
                            ></div>
                            <br></br>
                            <div
                              style={{
                                display: 'flex',
                                textAlign: 'center',
                                justifyContent: 'center',
                                fontSize: '15px',
                                color: 'darkgray',
                                fontWeight: '400',
                                paddingBottom: '21px',
                              }}
                            >
                              {' '}
                              A receipt will also be emailed to the customer{' '}
                            </div>
                          </form>
                        </div>
                      </p>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
